/** Three jobs on the book — one today, two later in the week. */

import type { Booking } from '../../types';
import { DEMO_WEBSITE_ID } from './site';
import { dayKey, daysAgo, hoursAgo } from './time';

export const demoBookings: Booking[] = [
  {
    id: 'demo-booking-1',
    customerName: 'Dana Kowalczyk',
    customerPhone: '(608) 555-0176',
    customerEmail: 'dana.k@example.com',
    serviceType: 'Drain cleaning',
    date: dayKey(0),
    time: '14:00',
    duration: 90,
    status: 'confirmed',
    notes: 'Kitchen sink, both basins slow. Park in the alley.',
    createdAt: daysAgo(2),
    websiteId: DEMO_WEBSITE_ID,
  },
  {
    id: 'demo-booking-2',
    customerName: 'Priya Raman',
    customerPhone: '(608) 555-0117',
    customerEmail: 'praman@example.com',
    serviceType: 'Water heater estimate',
    date: dayKey(1),
    time: '09:30',
    duration: 45,
    status: 'pending',
    notes: 'Bring the 50-gallon spec sheet.',
    createdAt: hoursAgo(19),
    websiteId: DEMO_WEBSITE_ID,
  },
  {
    id: 'demo-booking-3',
    customerName: 'Tom Ridgway',
    customerPhone: '(608) 555-0192',
    serviceType: 'Remodel rough-in walkthrough',
    date: dayKey(3),
    time: '11:00',
    duration: 60,
    status: 'confirmed',
    notes: '1948 house, hall bathroom. Contractor will be on site.',
    createdAt: daysAgo(3),
    websiteId: DEMO_WEBSITE_ID,
  },
];
